<template>
    <div class="container-fluid bg-white border rounded-3 p-4">
        <h2>Reasons for Visit</h2>
        <hr />

        <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-else-if="errorMessage" class="alert alert-danger">
            {{ errorMessage }}
        </div>

        <div v-else>
            <div class="mb-3 text-end">
                <button class="btn btn-sm btn-success" @click="$router.push({ name: 'reason-create' })">
                    ➕ Add New Reason
                </button>
            </div>

            <!-- <div v-if="reasons.length === 0" class="alert alert-warning">
                No reasons found.
            </div> -->

            <table class="table table-bordered text-start">
                <thead>
                    <tr>
                        <th class="text-start">#</th>
                        <th class="text-start">Reason Title</th>
                        <th class="text-start">Treatment Plans</th>
                        <th class="text-start">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(reason, index) in reasons" :key="reason.id">
                        <td class="text-start">{{ index + 1 }}</td>
                        <td class="text-start">{{ reason.title }}</td>
                        <td class="text-start">
                            <ul class="mb-0 ps-3">
                                <li v-for="(plan, i) in reason.treatment_plans" :key="i">
                                    {{ plan.title }}
                                </li>
                            </ul>
                        </td>
                        <td class="text-start">
                            <button class="btn btn-sm btn-primary me-1" @click="editReason(reason.id)">✏️ Edit</button>
                            <button class="btn btn-sm btn-danger" @click="deleteReason(reason.id)">🗑️ Delete</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReasonList',
    data() {
        return {
            loading: true,
            errorMessage: '',
            reasons: []
        }
    },
    methods: {
        async fetchReasons() {
            this.loading = true;
            try {
                const res = await this.$api.get('/reasons');
                this.reasons = res.data;
            } catch (err) {
                this.errorMessage = err.response?.data?.message || 'Failed to load reasons.';
            } finally {
                this.loading = false;
            }
        },
        editReason(id) {
            this.$router.push({ name: 'reason-edit', params: { id } });
        },
        async deleteReason(id) {
            if (!confirm('Are you sure you want to delete this reason?')) return;

            try {
                await this.$api.delete(`/reasons/${id}`);
                this.reasons = this.reasons.filter(r => r.id !== id);
            } catch (err) {
                alert(err.response?.data?.message || 'Failed to delete.');
            }
        }
    },
    mounted() {
        this.fetchReasons();
    }
}
</script>

<style scoped>
.card-title {
    font-weight: bold;
}
</style>